(() => {
  'use strict';
  const wrapper = document.querySelector('[data-bf-native-signup]');
  if (!wrapper) return;
  const container = wrapper.querySelector('#mktr-embedded-form-container-6adb6c9d28c48b6c03013797');
  const fallback = wrapper.querySelector('[data-bf-signup-fallback]');
  const message = wrapper.querySelector('[data-bf-signup-message]');
  const retry = wrapper.querySelector('[data-bf-signup-retry]');
  if (!container || !fallback || !message || !retry) return;
  let loaded = false;
  let timeout;

  // The native form's BF tagging was verified for existing subscribers. Some
  // responses still return its old wording; normalize only that exact message.
  // Native validation, visibility and success/error states remain untouched.
  function normalizeNativeFeedback() {
    container.querySelectorAll('.mkt-embedded-form-input-label > span.mkt-embedded-form-error-input-message').forEach(element => {
      if (element.textContent.trim() === 'Adresa ta este deja abonata la newsletter') {
        element.textContent = 'Ești pe lista Black Friday. Te anunțăm pe email la start.';
      }
    });
  }
  const feedbackObserver = new MutationObserver(normalizeNativeFeedback);
  feedbackObserver.observe(container, {childList: true, subtree: true, characterData: true});
  normalizeNativeFeedback();

  // Detect visible native form UI only. Sending, consent and contact tagging
  // stay inside theMarketer; no synthetic subscription event is emitted here.
  function checkForm() {
    if (loaded) return;
    const content = container.querySelector('form, input[type="email"], iframe');
    const rect = container.getBoundingClientRect();
    if (!content || rect.width === 0 || rect.height === 0) return;
    loaded = true;
    fallback.hidden = true;
    clearTimeout(timeout);
    observer.disconnect();
  }
  const observer = new MutationObserver(checkForm);
  observer.observe(container, {childList: true, subtree: true, attributes: true});
  retry.addEventListener('click', () => window.location.reload());
  document.addEventListener('bf:phasechange', checkForm);
  window.addEventListener('resize', checkForm, {passive: true});
  container.addEventListener('load', checkForm, true);
  timeout = setTimeout(() => {
    checkForm();
    if (loaded) return;
    message.textContent = 'Formularul nu s-a încărcat încă. Reîncarcă pagina pentru a încerca din nou.';
    retry.hidden = false;
  }, 12000);
  checkForm();
})();
